var map = {
	"./1.png": 1263,
	"./2.png": 3965,
	"./3.png": 6581,
	"./4.png": 9255,
	"./5.png": 5374,
	"./6.png": 4982,
	"./7.png": 9324,
	"./8.png": 8240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9361;